import React from 'react'
import { NavLink } from 'react-router-dom';

interface Props {
    breadCrumbList: any;
}

export const Breadcrumb: React.FC<Props> = (props: Props) => {
    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-12 px-0'>
                    <div>
                        <nav aria-label="breadcrumb" className="first">
                            <ol className="breadcrumb indigo lighten-6 my-3 navbar-light ">
                                {props.breadCrumbList.map((item: any, i: number) => (
                                    <li key={i} className={`${item.isActive ? 'breadcum-active-label' : 'breadcrumb-item font-weight-bold font-italic'}`}>
                                        < NavLink to={item.isActive ? undefined : item.routerLink} className={`${item.isActive ? 'black-text  active-1 text-decoration-none breadcrumb-text-color disabled-link fw-bold' : 'black-text breadcrumb-text-color fw-bold text-decoration-none'}`}>
                                            <span className={`${item.isActive ? 'breadcum-label' : 'breadcum-label mr-md-3 mr-2'}`}>{item.value}</span>
                                        </NavLink>
                                        <i className={`${item.isActive ? '' : 'bi bi-chevron-right breadcum-arrow'}`}></i>
                                    </li>
                                ))}
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}
